<template>
  <transition name="fade">
    <new-message-mobile v-if="isUnReadMessage" />
  </transition>

  <transition name="fade">
    <TMmodal v-show="TMOpen" :isOpen="TMOpen" :type="'header'" @close="onCloseTM"/>
  </transition>

  <template v-if="type != 'empty'">
    <!-- <div class="fx">
      <ul class="fxhead">
        <li class="home" :class="{'on': $route.name === 'mobileMain'}"><a @click="goPageByName('mobileMain')"><em></em><span>홈</span></a></li>
        <li class="in" :class="{'on': $route.meta.gnbMenu === 'charge'}"><a @click="goPageByName('charge')"><em></em><span>{{$t('front.common.deposit')}}</span></a></li>
        <li class="outs" :class="{'on': $route.meta.gnbMenu === 'exchange'}"><a @click="goPageByName('exchange')"><em></em><span>{{$t('front.common.withdrawal')}}</span></a></li>
        <li class="point" :class="{'on': $route.meta.gnbMenu === 'point'}"><a @click="goPageByName('point')"><em></em><span>{{$t('front.common.point')}}</span></a></li>
        <li v-if="!userData" class="join" :class="{'on': $route.name === 'mobileJoin'}"><a @click="goPageByName('mobileJoin')"><em></em><span>회원가입</span></a></li>
        <li v-if="userData" class="logout"><a @click="signOut()"><em></em><span>{{$t('front.common.logout')}}</span></a></li>
      </ul>
    </div> -->

    <header>
      <div class="header">
        <h1 class="logo"><a @click="goPageByName('mobileMain')"><img src="@/assets/img/mega-logo.png" /></a></h1>
        <div class="logininfowrap" v-if="userData">
          <span class="sideBtn" @click="side=!side"></span>
          <!-- <ul class="mym">
            <li class="myc" @click="goPageByName('charge')">
               <span>
                  <em>{{$t('front.cash.haveCash')}}</em>
                  {{userData.cashAmt ? thousand(userData.cashAmt.toString()): 0}}
               </span>
               <i>+</i>
            </li>
            <li class="myc" @click="goPageByName('point')">
               <span>
                  <em>{{$t('front.cash.nav4')}}</em>
                  {{thousand(userData.pointAmt ? userData.pointAmt.toString() : '0')}}
               </span>
               <i>+</i>
            </li>
          </ul>
          <a @click="goPageByName('msgMain')" class="mymsg"><img src="@/assets_mobile/img/message_off.svg" /><span class="mgsn">{{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}}</span></a>
          <a @click="goPageByName('info')" class="myin"><img src="@/assets_mobile/img/icon_m_user.svg" /></a> -->
        </div>
        <div class="logininfowrap" v-if="!userData">
          <!-- <a class="mloginbtn" @click="goPageByName('mobileLogin')">로그인</a> -->
          <span class="sideBtn" @click="side=!side"></span>
        </div>
      </div>
      <div class="mobileUserBar" v-if="userData">
        <div class="mobileUserTop">
          <span class="userId">{{ userData.memId }}</span>
        </div>
        <div class="mobileUserInfo">
          <p class="msgBtn" @click="goPageByName('msgMain')">
            쪽지 <em>({{ thousand(unReadMessageCount ? unReadMessageCount.toString() : '0') }})</em>
          </p>
          <p>
            보유머니
            <em>{{ userData.cashAmt ? thousand(userData.cashAmt.toString()) : '0' }}</em>원
          </p>
          <p>
            포인트
            <em>{{ userData.pointAmt ? thousand(userData.pointAmt.toString()) : '0' }}</em>P
          </p>
        </div>
      </div>
      <!-- <div class="topbanner">
        <div class="topbannerin">
            <div class="speakerIcon"><img src="@/assets/img/icon_mega.svg"/></div>
            <span class="">{{$t('front.header.msg')}}</span>
        </div>
      </div> -->
    </header>
    <transition name="side">
       <nav v-if="side">
         <div class="nav-wrap">
            <div class="nav-head">
               <div class="header">
                 <h1 class="logo"><a @click="goPageByNamez('mobileMain')"><img src="@/assets/img/mega-logo.png" /></a></h1>
               </div>
               <a class="sideMenu" @click="side=!side" :class="{'in': side}"><img src="@/assets/img/icon_x.svg" /></a>
            </div>
            <div class="nav-con">
              <div class="mobileSideProfile" v-if="userData">
                <div class="mobileSideProfileTop">
                  <span class="mobileSideUser">{{ userData.memId }}님</span>
                  <span class="mobileSideMsg" @click="goPageByNamez('msg')">
                    쪽지함 : <em>({{ thousand(unReadMessageCount ? unReadMessageCount.toString() : '0') }})</em>
                  </span>
                </div>

                <div class="mobileSideMoneyRow">
                  <p>
                    보유머니
                    <em>{{ userData.cashAmt ? thousand(userData.cashAmt.toString()) : '0' }}</em>원
                  </p>
                  <p>
                    포인트
                    <em>{{ userData.pointAmt ? thousand(userData.pointAmt.toString()) : '0' }}</em>원
                  </p>
                </div>
              </div>
              <div class="mobileSideGrid">
                <a class="mobileSideBtn dark" @click="goPageByNamez('listcasino')">
                  <img src="@/assets/img/left/icon_game01.png" />
                  <span>라이브카지노</span>
                </a>

                <a class="mobileSideBtn dark" @click="goPageByNamez('listslot')">
                  <img src="@/assets/img/left/icon_game02.png" />
                  <span>슬롯게임</span>
                </a>

                <a class="mobileSideBtn green" @click="goPageByNamez('qnaList')">
                  <span>고객센터</span>
                </a>

                <a class="mobileSideBtn green" @click="goPageByNamez('noticeList')">
                  <span>공지사항</span>
                </a>

                <a class="mobileSideBtn green" @click="goPageByNamez('charge')">
                  <span>입금신청</span>
                </a>

                <a class="mobileSideBtn green" @click="goPageByNamez('point')">
                  <span>포인트전환</span>
                </a>

                <a class="mobileSideBtn green" @click="goPageByNamez('exchange')">
                  <span>출금신청</span>
                </a>

                <a class="mobileSideBtn green" @click="goPageByNamez('betList')">
                  <span>베팅내역</span>
                </a>

                <a class="mobileSideBtn green"  v-if="userData && userData.isPartnerMember === 'Y'" :href="`https://${partnerDomain}/partnerMain`" target="_blank">
                  <span>파트너페이지</span>
                </a>

                <a class="mobileSideBtn gray" @click="onLogOut">
                  <span>로그아웃</span>
                </a>
              </div>
              <ul>
                <li>
                  <a @click="goPageByNamez('msg')">
                    <img src="@/assets/img/left/icon_left_msg.svg" />
                    <span>{{$t('front.mypage.msg')}} ({{thousand(unReadMessageCount ? unReadMessageCount.toString() : '0')}})</span>
                  </a>
                </li>
                <li>
                  <a @click="goPageByNamez('qnaList')">
                      <img src="@/assets/img/left/icon_left_ask.svg" />
                      <span>{{$t('front.common.cscenter')}}</span>
                  </a>
                </li>
                <li>
                    <a @click="goPageByNamez('charge')">
                        <img src="@/assets/img/left/icon_left_in.svg" />
                        <span>{{$t('front.common.deposit')}}</span>
                    </a>
                </li>
                <li>
                    <a @click="goPageByNamez('exchange')">
                        <img src="@/assets/img/left/icon_left_out.svg" />
                        <span>{{$t('front.common.withdrawal')}}</span>
                    </a>
                </li>
                <li>
                  <a @click="goPageByNamez('betList')">
                      <img src="@/assets/img/left/icon_left_bet.svg" />
                      <span>{{$t('front.mypage.betList')}}</span>
                  </a>
                </li>
                <li>
                  <a @click="goPageByNamez('point')">
                      <img src="@/assets/img/left/icon_left_point.svg" />
                      <span>{{$t('front.common.point')}}</span>
                  </a>
                </li>
                <li>
                  <a @click="goPageByNamez('coupon')">
                      <img src="@/assets/img/left/icon_left_point.svg" />
                      <span>{{$t('front.common.coupon')}}</span>
                  </a>
                </li>
                <li>
                  <a @click="goPageByNamez('noticeList')">
                      <img src="@/assets/img/left/icon_left_notice.svg" />
                      <span>{{$t('front.common.notice')}}</span>
                  </a>
                </li>
                <li>
                    <a @click="goPageByNamez('info')">
                        <img src="@/assets/img/left/icon_left_info.svg" />
                        <span>{{$t('front.mypage.memInfoModify')}}</span>
                    </a>
                </li>
              </ul>
            </div>
          </div>
       </nav>
    </transition>
  </template>
</template>

<script>
import { mapState } from 'vuex'
import NewMessageMobile from '@/components/member/MessageMobile.vue'
import TMmodal from '@/components/common/TotalMoney.vue'

export default {
  name: 'Header',
  components: { TMmodal, NewMessageMobile },
  props: [
    'type'
  ],
  data () {
    return {
      isOpenLang: false,
      side: false,
      TMOpen: false
    }
  },
  computed: {
    ...mapState([
      'userData',
      'unReadMessageCount'
    ]),
    isUnReadMessage () {
      return this.unReadMessageCount && this.unReadMessageCount && this.unReadMessageCount !== '0' && this.$route.name.indexOf('message') === -1 && this.$route.name.indexOf('msg') === -1
    },
    partnerDomain () {
      const hostname = window.location.hostname
      if (hostname.includes('port-folio.cc')) return 'd29.port-folio.cc' // 두번째 도메인
      return 'd29.port-folio.cc' // 기본값
    }
  },
  methods: {
    async onClickTM () {
      const confirmMessage = '통합머니 전환을 진행하시겠습니까?'
      const confirmResult = await this.onConfirm(confirmMessage)
      if (confirmResult) {
        this.TMOpen = true
      }
    },
    onCloseTM () {
      this.TMOpen = false
    },
    openLang () {
      this.isOpenLang = !this.isOpenLang
    },
    onLogOut () {
      this.$root.signOut()
      this.$router.push({ name: 'main' })
      // location.reload()
    },
    goPageByNamez (name, params) {
      const query = { name: name }
      if (params) {
        query.params = params
      }
      this.$router.push(query)
      this.side = !this.side
    }
  }
}
</script>

<style scoped src="@/styles_mobile/header.css"></style>
<style scoped src="@/styles_mobile/common.css"></style>
<style scoped src="@/styles_mobile/swiper.min.css"></style>
<style scoped src="@/styles_mobile/subcommon.css"></style>
